import { FORMAT_NUMBER, PERCENTAGE_FORMAT } from "../../../../common/utils";

const CompanyChartCoinKey = props => {
  const { statsData, currencySign } = props;

  return (
    <div className="event-page-company-chart-section">
      <div className="event-page-company-chart-section-title">Key stats</div>
      <div className="event-page-company-chart-section-row">
        {statsData?.market_cap ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Market Cap
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(statsData?.market_cap, currencySign)}
            </div>
          </div>
        ) : null}

        {statsData?.market_cap_dominance ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Market Cap Dominance (%)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {PERCENTAGE_FORMAT(statsData?.market_cap_dominance)}
            </div>
          </div>
        ) : null}

        {statsData?.market_cap ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Fully Diluted Market Cap
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(statsData?.fully_diluted_market_cap, currencySign)}
            </div>
          </div>
        ) : null}
        {statsData?.tvl ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Total Value Locked (TVL)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(statsData?.tvl, currencySign)}
            </div>
          </div>
        ) : null}

        {statsData?.max_supply ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Max Supply
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(statsData?.max_supply, currencySign)}
            </div>
          </div>
        ) : null}

        {statsData?.circulating_supply ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Circulating Supply
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(statsData?.circulating_supply, currencySign)}
            </div>
          </div>
        ) : null}
        {statsData?.total_supply ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Total Supply
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(statsData?.total_supply, currencySign)}
            </div>
          </div>
        ) : null}

        {statsData?.num_market_pairs ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Number of Market Pairs
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(statsData?.num_market_pairs)}
            </div>
          </div>
        ) : null}

        <div className="event-page-company-chart-section-row-item">
          <div className="event-page-company-chart-section-row-item-label">
            Infinite Supply
          </div>
          <div className="event-page-company-chart-section-row-item-text">
            {statsData?.infinite_supply ? "Yes" : "No"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyChartCoinKey;
